export { PrivacyPageComponent } from './privacy-page.component';
export { PrivacyPageModule } from './privacy-page.module';
